/* Require every word in a search, instead of any word.

   Shopify's storefront search treats a multi-word query as "match ANY of these words",
   so "black lining set" also returns every black handle and every door set — 350 results
   where only a handful are relevant. Its query syntax does support AND, so the query is
   rewritten on submit ("black lining set" -> "black AND lining AND set", 22 results).

   The typed words are left alone if the shopper is already using search operators, and
   main-search.liquid strips the ANDs back out for display and falls back to the loose
   search if the strict one finds nothing.
*/
(function () {
  var OPERATORS = /^(AND|OR|NOT)$/i;

  /* Words the trade uses interchangeably. "Prefinished" and "fully finished" are the same
     product to a customer, but Shopify treats them as different words, so a search for one
     missed hundreds of doors described as the other. Each phrase below is rewritten to the
     wording the catalogue actually uses before the search runs. */
  var SYNONYMS = [
    { match: /\bpre[\s-]?finished\b/gi, replace: 'fully finished' },
    { match: /\bprefinish\b/gi, replace: 'fully finished' },
  ];

  function normalise(value) {
    var out = value;
    SYNONYMS.forEach(function (rule) {
      out = out.replace(rule.match, rule.replace);
    });
    return out;
  }

  function strict(value) {
    var normalised = normalise(value).trim();
    var words = normalised.split(/\s+/).filter(Boolean);
    // Even when the query is left loose, the synonym still applies - otherwise
    // "prefinished oak -fire" would go back to missing the fully finished doors.
    if (words.length < 2) return normalised;
    // Respect a shopper who is writing their own query: operators, exclusions, quotes.
    for (var i = 0; i < words.length; i++) {
      if (OPERATORS.test(words[i]) || words[i].charAt(0) === '-' || words[i].indexOf('"') > -1) {
        return normalised;
      }
    }
    return words.join(' AND ');
  }

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || !form.action || form.action.indexOf('/search') === -1) return;
      var input = form.querySelector('input[name="q"]');
      if (input && input.value) input.value = strict(input.value);
    },
    true
  );

  // The predictive dropdown's suggested searches are plain links, so they bypass submit.
  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('.predictive-search a[href*="/search"]');
    if (!link) return;
    var url;
    try {
      url = new URL(link.href, window.location.origin);
    } catch (e) {
      return;
    }
    var q = url.searchParams.get('q');
    if (!q) return;
    url.searchParams.set('q', strict(q));
    link.href = url.pathname + url.search;
  });
})();
